export { default as InformationIcon } from './InformationIcon'
